<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '480px' }" [header]="header()" (onHide)="close()">
  <div class="setup">
    @switch (step()) {
      @case ('password') {
        <p class="setup__lead">
          {{ 'Signing_Setup_Password_Lead' | translateWF: 'To sign documents you need Microsoft Authenticator on your phone. First, confirm your Nexus password.' }}
        </p>
        <div class="setup__field" (keydown.enter)="submitPassword()">
          <label for="setup-password">{{ 'Signing_Setup_Password' | translateWF: 'Password' }}</label>
          <p-password
            inputId="setup-password"
            [(ngModel)]="password"
            [feedback]="false"
            [toggleMask]="true"
            [disabled]="busy()"
            styleClass="w-full"
            inputStyleClass="w-full"
            placeholder="{{ 'Signing_Setup_Password_Placeholder' | translateWF: 'Enter your password' }}"
          />
        </div>
      }

      @case ('scan') {
        @if (enrollment(); as data) {
          <ol class="setup__steps">
            <li>
              {{ 'Signing_Setup_Step1' | translateWF: 'Install Microsoft Authenticator from the App Store or Google Play.' }}
            </li>
            <li>
              {{ 'Signing_Setup_Step2' | translateWF: 'In the app, tap + → Other account (Google, Facebook, etc.) and scan this code.' }}
            </li>
            <li>{{ 'Signing_Setup_Step3' | translateWF: 'Type the 6-digit code the app shows for Sierra Nexus.' }}</li>
          </ol>

          <div class="setup__qr">
            <img [src]="data.qrCodeDataUri" alt="{{ 'Signing_Setup_Qr_Alt' | translateWF: 'QR code to set up the authenticator' }}" />
          </div>

          <div class="setup__secret">
            <span class="setup__secret-label">{{ 'Signing_Setup_Manual' | translateWF: "Can't scan it? Enter this key manually:" }}</span>
            <div class="setup__secret-row">
              <code class="setup__secret-value">{{ data.secret }}</code>
              <p-button variant="text" icon="pi pi-copy" [pTooltip]="'Signing_Setup_Copy' | translateWF: 'Copy key'" tooltipPosition="top" (onClick)="copySecret()" />
            </div>
            <span class="setup__secret-hint">{{ 'Signing_Setup_Account' | translateWF: 'Account' }}: {{ data.issuer }} ({{ data.accountName }})</span>
          </div>

          <div class="setup__inputs" (keydown.enter)="confirmCode()">
            <p-inputotp [(ngModel)]="code" [length]="6" [integerOnly]="true" [disabled]="busy()" />
          </div>
        }
      }

      @case ('done') {
        <div class="setup__center">
          <i class="pi pi-check-circle setup__icon"></i>
          <p class="setup__text">
            {{ 'Signing_Setup_Done' | translateWF: 'Your authenticator is ready. From now on, use the code from the app every time you open a signing session.' }}
          </p>
        </div>
      }
    }

    @if (error()) {
      <div class="setup__error">{{ error() }}</div>
    }
  </div>

  <ng-template #footer>
    @switch (step()) {
      @case ('password') {
        <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="close()" />
        <p-button label="{{ 'Signing_Setup_Continue' | translateWF: 'Continue' }}" [disabled]="!password" [loading]="busy()" (onClick)="submitPassword()" />
      }
      @case ('scan') {
        <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="close()" />
        <p-button label="{{ 'Signing_Setup_Confirm' | translateWF: 'Activate' }}" [disabled]="code.length !== 6" [loading]="busy()" (onClick)="confirmCode()" />
      }
      @case ('done') {
        <p-button variant="text" label="{{ 'Signing_Close' | translateWF: 'Close' }}" (onClick)="close()" />
        <p-button icon="pi pi-lock-open" label="{{ 'Signing_Dashboard_NewSession' | translateWF: 'New Session' }}" (onClick)="goToSession()" />
      }
    }
  </ng-template>
</p-dialog>
